import React from "react";
import {Button } from "react-scroll";

export const AboutUs = () => {

  const [readMore, setReadMore] = React.useState(false);

  return (
    <section id="about" className="py-24 h-auto md:h-screen relative">
      <div
        style={{
          backgroundImage: 'url(/hero_building.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        className="absolute top-0 left-0 w-full h-full bg-cover bg-center"
      />
      <div className="max-w-[90vw] mx-auto px-4 relative z-[1]">
        <div className="md:mr-[20vw] items-center justify-end">
          {/* Text Container */}
          <div className="bg-white p-[40px] rounded-lg shadow-lg md:self-end flex flex-col justify-end items-start transition-transform hover:translate-x-[15px] duration-300">
            <div className="mb-3">
              <span className="text-xl font-bold mr-1">About</span>
              <span className="text-xl font-bold text-green-600">Us </span>

            </div>
            <div className="text-2xl md:text-4xl font-bold text-green-900 mb-6">
              Building Wealth Today, Creating Legacies for Tomorrow
            </div>
            <p className="text-base md:text-lg text-gray-600 mb-6">
            At Evergreen Growth Partners, we are a boutique advisory firm committed to serving the mid-market segment. Our expertise spans SME IPO advisory, mergers and acquisitions (M&A), structured finance and wealth management services.
            </p>
{readMore &&
            <div>
            <p className="text-base md:text-lg text-gray-600 mb-6">
            Founded by an experienced professional with rich experience at leading global firms in investment banking and private equity, Evergreen Growth Partners was created to provide clients with a clear focus on delivering tailored, value-driven solutions.
            </p>

            <p className="text-base md:text-lg text-gray-600 mb-6">

            We pride ourselves on our deep industry insights, personalized approach and unwavering commitment to helping businesses and individuals achieve their financial ambitions.
            </p>
            </div>
            }
            {!readMore? 
            <Button smooth={true} duration={500} to="about" className="border-green-600 border-2 border-solid text-gray-700 px-6 py-2 rounded-full hover:bg-green-700 hover:text-white"
          onClick={() => setReadMore(!readMore)}>
              Read More
            </Button>
            :``}
            <p
              className="
              mt-5
              text-sm text-green-600 italic 
              animate-fadeInUp"
            >
              "Enduring wealth is not just about growing assets - it’s about creating a future that thrives beyond your lifetime."
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
